// exercisePicks.js — the user's EXPLICIT exercise preferences for the AI
// Workout Generator (distinct from the behavioural prefer/avoid that
// aiWorkoutSmart.exercisePreferences infers from skips/swaps).
//
//   liked[id]  → "I like this — suggest it" (always offered to the model,
//                bypassing the per-muscle candidate cap, and flagged preferred)
//   hidden[id] → "don't suggest this" (dropped from the candidate pool)
//
// Liking and hiding are mutually exclusive. Stored under one localStorage key
// and broadcast so an open generator re-reads on change.

const KEY = "riyadahExercisePicks";

export function loadExercisePicks() {
  try {
    const p = JSON.parse(localStorage.getItem(KEY) || "{}");
    return { liked: p.liked || {}, hidden: p.hidden || {} };
  } catch { return { liked: {}, hidden: {} }; }
}

function save(p) {
  try { localStorage.setItem(KEY, JSON.stringify(p)); } catch {}
  try { window.dispatchEvent(new CustomEvent("exercise-picks-updated")); } catch {}
  return p;
}

export function toggleLikedExercise(id) {
  const p = loadExercisePicks();
  if (p.liked[id]) { delete p.liked[id]; }
  else { p.liked[id] = true; delete p.hidden[id]; } // liking clears a hide
  return save(p);
}

export function toggleHiddenExercise(id) {
  const p = loadExercisePicks();
  if (p.hidden[id]) { delete p.hidden[id]; }
  else { p.hidden[id] = true; delete p.liked[id]; } // hiding clears a like
  return save(p);
}

export function likedExerciseIds()  { return Object.keys(loadExercisePicks().liked); }
export function hiddenExerciseIds() { return Object.keys(loadExercisePicks().hidden); }

// A YouTube *search* (not a hard-coded video) so links never rot and always
// surface current top form tutorials for the exact exercise name.
export function youtubeHowToUrl(name) {
  return "https://www.youtube.com/results?search_query=" + encodeURIComponent(`how to ${name} proper form technique`);
}

// Whether to show ▶ how-to links on the generated workout. Default on.
const HOWTO_KEY = "riyadahShowHowToLinks";
export function showHowToLinks() {
  try { return localStorage.getItem(HOWTO_KEY) !== "false"; } catch { return true; }
}
export function setShowHowToLinks(on) {
  try { localStorage.setItem(HOWTO_KEY, on ? "true" : "false"); } catch {}
  try { window.dispatchEvent(new CustomEvent("exercise-picks-updated")); } catch {}
}
